import { Giving } from './Giving';
import { GivingContextProvider } from '../../../contexts/Giving';

export default props => {
    return (
        <GivingContextProvider>
            <Giving {...props} />
        </GivingContextProvider>
    );
};
